/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_History_ErrorInputs */

const en_case_history_error = /** @type {(inputs: Case_History_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The history could not be loaded.`)
};

const pt_br2_case_history_error = /** @type {(inputs: Case_History_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível carregar o histórico.`)
};

/**
* | output |
* | --- |
* | "The history could not be loaded." |
*
* @param {Case_History_ErrorInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_history_error = /** @type {((inputs?: Case_History_ErrorInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_History_ErrorInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_history_error(inputs)
	return pt_br2_case_history_error(inputs)
});